/* eslint-disable functional/no-let, functional/no-loop-statement */
/* eslint-disable functional/no-expression-statement */
import _ from 'lodash';
import qs from 'qs';
import fetchHelper from './fetchHelper';
import HttpError from './HttpError';

export default async function fetchAll<T>(
  token: string,
  url: string,
  params: object = {},
  limit: number = 500,
  envelop: string = 'data',
): Promise<readonly T[] | HttpError> {
  let counter = 0;
  let length = limit;
  let results = [] as readonly T[];
  while (length === limit) {
    const newUrl = `${url}?${qs.stringify({ ...params, limit, offset: limit * counter })}`;
    // eslint-disable-next-line no-await-in-loop
    const newResults = await fetchHelper(token, 'GET', newUrl);
    if (newResults instanceof HttpError) {
      return newResults;
    }
    const data = _.get(newResults, envelop, [] as readonly T[]);
    results = results.concat(data);
    // eslint-disable-next-line prefer-destructuring
    length = data.length;
    counter += 1;
  }

  return results;
}
